import Cookies from 'js-cookie'

import compactObject from '@/utils/compact-object'
import {CookieName} from '@helios/shared/config/param-cookies'
import {useLocale} from '@helios/shared/providers/locale'

type Args = {
    redirectPath?: string
    params?: Record<string, string>
}

export const useSignupRedirect = (args?: Args) => {
    const currentLocale = useLocale()
    const redirectPath = currentLocale.isPreLaunch ? '/join-early' : args?.redirectPath

    if (redirectPath) {
        return appendParams(redirectPath, new URLSearchParams(args?.params))
    }

    const params = new URLSearchParams(
        compactObject({
            ...args?.params,
            lang: currentLocale.language,
            locale: currentLocale.code,
            pt_ref: 'website',
            utm_source: Cookies.get(CookieName.UTM_SOURCE) || '',
            utm_medium: Cookies.get(CookieName.UTM_MEDIUM) || '',
            utm_campaign: Cookies.get(CookieName.UTM_CAMPAIGN) || '',
            utm_term: Cookies.get(CookieName.UTM_TERM) || '',
            utm_content: Cookies.get(CookieName.UTM_CONTENT) || '',
            latest_utm_source: Cookies.get(CookieName.LATEST_UTM_SOURCE) || '',
            latest_utm_medium: Cookies.get(CookieName.LATEST_UTM_MEDIUM) || '',
            latest_utm_campaign: Cookies.get(CookieName.LATEST_UTM_CAMPAIGN) || '',
            latest_utm_term: Cookies.get(CookieName.LATEST_UTM_TERM) || '',
            latest_utm_content: Cookies.get(CookieName.LATEST_UTM_CONTENT) || '',
            referral_id: Cookies.get(CookieName.REFERRAL_CODE) || '',
            s_id: Cookies.get(CookieName.FINANCE_ADS_COOKIE_NAME) || '',
        })
    )

    return `${process.env.GATSBY_PLEO_APP_URL}/register?${params}`
}

const appendParams = (path: string, params: URLSearchParams) => {
    if (Boolean(Array.from(params.keys()).length)) {
        return `${path}?${params}`
    }

    return path
}
